import { render, staticRenderFns } from "./PromoCodesButton.vue?vue&type=template&id=4288575a&scoped=true&"
import script from "./PromoCodesButton.vue?vue&type=script&lang=ts&"
export * from "./PromoCodesButton.vue?vue&type=script&lang=ts&"
import style0 from "./PromoCodesButton.vue?vue&type=style&index=0&id=4288575a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4288575a",
  null
  
)

export default component.exports